import { NoPaid as NpPaidIcon } from '@shared/assets';
import * as st from './styles.module.scss';

type Props = {
  isPaid?: boolean;
};

export const NoPaid: React.FC<Props> = ({ isPaid }) => {
  return (
    <>
      {!isPaid && (
        <div className={st.noPaid}>
          <NpPaidIcon />
        </div>
      )}
    </>
  );
};
